// src/components/ColorPicker.tsx
// Accent color selector with circle swatches.

import { cn } from '@core/ui';

interface ColorOption {
  value: string;
  label: string;
}

interface ColorPickerProps {
  options: readonly ColorOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function ColorPicker({ options, value, onChange, className }: ColorPickerProps) {
  return (
    <div className={cn('flex gap-3 flex-wrap', className)}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          title={opt.label}
          onClick={() => onChange(opt.value)}
          className={cn(
            'w-8 h-8 rounded-full transition-all',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary',
            value === opt.value && 'ring-2 ring-offset-2 ring-foreground scale-110',
          )}
          style={{ backgroundColor: opt.value }}
        />
      ))}
    </div>
  );
}
